import { Component, OnInit } from '@angular/core';

import { SessionService, SessionUserData } from '../common/session.service';

@Component({
  templateUrl: './settings.component.html'
})
export class SettingsComponent implements OnInit {
  user: SessionUserData;

  constructor(
    private session: SessionService,
  ) {}

  ngOnInit() {
    this.user = this.session.user();
  }
}



// WEBPACK FOOTER //
// /srv/src/app/settings/settings.component.ts